"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleAccess = exports.FEATURES = void 0;
const models_1 = require("../models");
var FEATURES;
(function (FEATURES) {
    FEATURES["CREATE_PATIENT_GROUP"] = "createPatientGroup";
    FEATURES["VIEW_BROADCAST"] = "viewBroadcast";
    FEATURES["VIEW_HIDDEN_GROUPS"] = "viewHiddenGroups";
    FEATURES["VIEW_GROUP_SETTINGS"] = "viewGroupSettings";
    FEATURES["VIEW_USER_DIRECTORY"] = "viewUserDirectory";
    FEATURES["VIEW_INTERNAL_GROUPS"] = "viewInternalGroups";
    FEATURES["VIEW_REFERRAL_ALERTS"] = "viewReferralAlerts";
    FEATURES["VIEW_ORGANIZATION_MEDIA"] = "viewOrganizationMedia";
    FEATURES["CREATE_BROADCAST"] = "createBroadcast";
    FEATURES["CREATE_INTERNAL_GROUP"] = "createInternalGroup";
    FEATURES["DELETE_BROADCAST"] = "deleteBroadcast";
    FEATURES["ADD_EXTERNAL_USER_IN_PATIENT_GROUP"] = "addPatientPhysicianInPatientGroup";
    FEATURES["ADD_MEMBERS"] = "addMembers";
    FEATURES["SEND_REFERRALS"] = "sendReferrals";
    FEATURES["ADVANCE_SEARCH"] = "advanceSearch";
    FEATURES["SHOW_FULL_USER_DIRECTORY"] = "showFullUserDirectory";
    FEATURES["ADMIN_PANEL"] = "adminPanel";
    FEATURES["VIEW_ASSIGNED_PATIENTS"] = "viewAssignedPatients";
    FEATURES["VIEW_DELETED_MESSAGES"] = "viewDeletedMessages";
    FEATURES["REMOVE_MEMBERS"] = "removeMembers";
    FEATURES["REVOKE_REFERRALS"] = "revokeReferrals";
    FEATURES["MANAGE_RPM_DEVICES"] = "manageRpmDevices";
    FEATURES["EXPORT_RPM_READINGS"] = "exportRpmReadings";
    // Patient-group Info tab, hidden from the patient but visible to physician (ASU+PHY):
    // Referral Info + Referral Files, Media/Docs/Links, Caregiver details, Pharmacy details.
    FEATURES["VIEW_PATIENT_INFO"] = "viewPatientInfo";
    // Group Info tab, internal/staff-only sections — ASU:
    // patient group: Send Emails, About, Export Settings (hidden from patient + physician);
    // internal group: Send Emails (hidden from physician; About/Media stay visible).
    FEATURES["VIEW_GROUP_INTERNAL_INFO"] = "viewGroupInternalInfo";
    // Patient-group Info tab: "Start New Episode" action (ADMIN/STAFF only).
    FEATURES["START_NEW_EPISODE"] = "startNewEpisode";
    FEATURES["EDIT_GROUP"] = "editGroup";
    FEATURES["VIEW_CARE_TIMELINE"] = "viewCareTimeline";
    FEATURES["FILTER_BY_SERVICE_STATUS"] = "filterByServiceStatus";
    FEATURES["SORT_BY_PENDING_REFERRALS"] = "sortByPendingReferrals";
    FEATURES["SEND_TEMPLATE_MESSAGE"] = "sendTemplateMessage";
    FEATURES["VIEW_CALENDAR_MAP"] = "viewCalendarMap";
    FEATURES["VIEW_PRIVATE_CALENDAR_MAP"] = "viewPrivateCalendarMap";
    FEATURES["OPEN_PRIVATE_CHAT_CALENDAR"] = "openPrivateChatCalendar";
    FEATURES["EXPORT_CHAT"] = "exportChat";
    FEATURES["VIEW_VITALS_TAB"] = "viewVitalsTab";
    FEATURES["ACCESS_LAB_REQUISITIONS"] = "accessLabRequisitions";
    // Settings "Add Patient" action — register a patient in the org (distinct from CREATE_PATIENT_GROUP).
    FEATURES["ADD_PATIENT"] = "addPatient";
    // Settings "Add User" action — register a staff/clinician user in the org.
    FEATURES["ADD_USER"] = "addUser";
    // Sync Queue screen — view EMR→HHN sync activity and approve/reject pending patients.
    FEATURES["MANAGE_SYNC_QUEUE"] = "manageSyncQueue";
    // EMR Setup screen — edit org sync settings (AdminAuth on the backend).
    FEATURES["MANAGE_SYNC_SETTINGS"] = "manageSyncSettings";
    // Auto Ack screen — manage auto-acknowledgement rules (AdminAuth on the backend).
    FEATURES["MANAGE_AUTO_ACK"] = "manageAutoAck";
    // Working hours & reminders screen — edit org general settings (AdminAuth on the backend).
    FEATURES["MANAGE_ORG_SETTINGS"] = "manageOrgSettings";
})(FEATURES || (exports.FEATURES = FEATURES = {}));
exports.roleAccess = {
    [models_1.USER_TYPE.ADMIN]: [
        FEATURES.VIEW_BROADCAST,
        FEATURES.VIEW_HIDDEN_GROUPS,
        FEATURES.VIEW_USER_DIRECTORY,
        FEATURES.VIEW_INTERNAL_GROUPS,
        FEATURES.VIEW_REFERRAL_ALERTS,
        FEATURES.VIEW_ORGANIZATION_MEDIA,
        FEATURES.VIEW_GROUP_SETTINGS,
        FEATURES.CREATE_BROADCAST,
        FEATURES.CREATE_INTERNAL_GROUP,
        FEATURES.DELETE_BROADCAST,
        FEATURES.ADD_EXTERNAL_USER_IN_PATIENT_GROUP,
        FEATURES.ADD_MEMBERS,
        FEATURES.SEND_REFERRALS,
        FEATURES.ADVANCE_SEARCH,
        FEATURES.SHOW_FULL_USER_DIRECTORY,
        FEATURES.ADMIN_PANEL,
        FEATURES.CREATE_PATIENT_GROUP,
        FEATURES.VIEW_ASSIGNED_PATIENTS,
        FEATURES.VIEW_DELETED_MESSAGES,
        FEATURES.REMOVE_MEMBERS,
        FEATURES.REVOKE_REFERRALS,
        FEATURES.MANAGE_RPM_DEVICES,
        FEATURES.EXPORT_RPM_READINGS,
        FEATURES.VIEW_PATIENT_INFO,
        FEATURES.VIEW_GROUP_INTERNAL_INFO,
        FEATURES.START_NEW_EPISODE,
        FEATURES.EDIT_GROUP,
        FEATURES.VIEW_CARE_TIMELINE,
        FEATURES.FILTER_BY_SERVICE_STATUS,
        FEATURES.SORT_BY_PENDING_REFERRALS,
        FEATURES.SEND_TEMPLATE_MESSAGE,
        FEATURES.VIEW_CALENDAR_MAP,
        FEATURES.VIEW_PRIVATE_CALENDAR_MAP,
        FEATURES.OPEN_PRIVATE_CHAT_CALENDAR,
        FEATURES.EXPORT_CHAT,
        FEATURES.VIEW_VITALS_TAB,
        FEATURES.ACCESS_LAB_REQUISITIONS,
        FEATURES.ADD_PATIENT,
        FEATURES.ADD_USER,
        FEATURES.MANAGE_SYNC_QUEUE,
        FEATURES.MANAGE_SYNC_SETTINGS,
        FEATURES.MANAGE_AUTO_ACK,
        FEATURES.MANAGE_ORG_SETTINGS,
    ],
    [models_1.USER_TYPE.STAFF]: [
        FEATURES.VIEW_BROADCAST,
        FEATURES.VIEW_HIDDEN_GROUPS,
        FEATURES.VIEW_USER_DIRECTORY,
        FEATURES.VIEW_INTERNAL_GROUPS,
        FEATURES.VIEW_REFERRAL_ALERTS,
        FEATURES.VIEW_ORGANIZATION_MEDIA,
        FEATURES.VIEW_GROUP_SETTINGS,
        FEATURES.CREATE_BROADCAST,
        FEATURES.CREATE_INTERNAL_GROUP,
        FEATURES.DELETE_BROADCAST,
        FEATURES.ADD_EXTERNAL_USER_IN_PATIENT_GROUP,
        FEATURES.ADD_MEMBERS,
        FEATURES.SEND_REFERRALS,
        FEATURES.ADVANCE_SEARCH,
        FEATURES.SHOW_FULL_USER_DIRECTORY,
        FEATURES.CREATE_PATIENT_GROUP,
        FEATURES.VIEW_ASSIGNED_PATIENTS,
        FEATURES.REMOVE_MEMBERS,
        FEATURES.REVOKE_REFERRALS,
        FEATURES.MANAGE_RPM_DEVICES,
        FEATURES.EXPORT_RPM_READINGS,
        FEATURES.VIEW_PATIENT_INFO,
        FEATURES.VIEW_GROUP_INTERNAL_INFO,
        FEATURES.START_NEW_EPISODE,
        FEATURES.EDIT_GROUP,
        FEATURES.VIEW_CARE_TIMELINE,
        FEATURES.FILTER_BY_SERVICE_STATUS,
        FEATURES.SORT_BY_PENDING_REFERRALS,
        FEATURES.SEND_TEMPLATE_MESSAGE,
        FEATURES.VIEW_CALENDAR_MAP,
        FEATURES.VIEW_PRIVATE_CALENDAR_MAP,
        FEATURES.OPEN_PRIVATE_CHAT_CALENDAR,
        FEATURES.EXPORT_CHAT,
        FEATURES.VIEW_VITALS_TAB,
        FEATURES.ACCESS_LAB_REQUISITIONS,
        FEATURES.ADD_PATIENT,
        FEATURES.MANAGE_SYNC_QUEUE,
    ],
    [models_1.USER_TYPE.USER]: [
        FEATURES.VIEW_BROADCAST,
        FEATURES.VIEW_HIDDEN_GROUPS,
        FEATURES.VIEW_GROUP_SETTINGS,
        FEATURES.VIEW_USER_DIRECTORY,
        FEATURES.VIEW_INTERNAL_GROUPS,
        FEATURES.VIEW_REFERRAL_ALERTS,
        FEATURES.VIEW_ORGANIZATION_MEDIA,
        FEATURES.CREATE_BROADCAST,
        FEATURES.CREATE_INTERNAL_GROUP,
        FEATURES.DELETE_BROADCAST,
        FEATURES.ADD_MEMBERS,
        FEATURES.REMOVE_MEMBERS,
        FEATURES.MANAGE_RPM_DEVICES,
        FEATURES.EXPORT_RPM_READINGS,
        FEATURES.VIEW_PATIENT_INFO,
        FEATURES.VIEW_GROUP_INTERNAL_INFO,
        FEATURES.EDIT_GROUP,
        FEATURES.VIEW_CARE_TIMELINE,
        FEATURES.FILTER_BY_SERVICE_STATUS,
        FEATURES.SEND_TEMPLATE_MESSAGE,
        FEATURES.VIEW_CALENDAR_MAP,
        FEATURES.EXPORT_CHAT,
        FEATURES.VIEW_VITALS_TAB,
        FEATURES.ACCESS_LAB_REQUISITIONS,
    ],
    [models_1.USER_TYPE.PHYSICIAN]: [
        FEATURES.VIEW_INTERNAL_GROUPS,
        FEATURES.EXPORT_RPM_READINGS,
        FEATURES.VIEW_ORGANIZATION_MEDIA,
        FEATURES.VIEW_PATIENT_INFO,
        FEATURES.EXPORT_CHAT,
        FEATURES.VIEW_VITALS_TAB,
        FEATURES.ACCESS_LAB_REQUISITIONS,
    ],
    [models_1.USER_TYPE.PATIENT]: [],
};
